// extracted by mini-css-extract-plugin
export default {"TitleHead":"Title_TitleHead__q7WHW","Contextcard":"Title_Contextcard__+To4z","filebox":"Title_filebox__VgrAB","uploadName":"Title_uploadName__DRKgH","file":"Title_file__a3abV"};